// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2SI7X","colMaxWidth":"Table_colMaxWidth__2GFo8"};